var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ModalAjoutProduitHM", {
        ref: "modalAjoutProduit",
        attrs: {
          listeFamillesFournisseurs: _vm.produitsHMtab,
          produit: _vm.produitSelectionne,
          fournisseur: _vm.tarifSelectionne,
          paramModale: _vm.paramModale
        },
        on: {
          "produit-modifie": function($event) {
            return _vm.chargerProduits(
              _vm.produitSelectionne.produit.produitId,
              _vm.produitSelectionne.famille.familleId
            )
          }
        }
      }),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreActions", {
            ref: "barreActions",
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _c(
            "div",
            { staticClass: "card table-scroll height-responsive-100" },
            [
              _c(
                "div",
                { staticClass: "card-header flex-center-space-between" },
                [
                  _c("div", { staticClass: "flex-start" }, [
                    _c("span", [_vm._v(_vm._s(_vm.titreProduit()))])
                  ])
                ]
              ),
              _vm._m(0),
              _c("div", { staticClass: "table-body" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-sm text-center" },
                  [
                    _vm._m(1),
                    _c(
                      "tbody",
                      _vm._l(_vm.listeTarifs, function(tarif, iTarif) {
                        return _c(
                          "tr",
                          {
                            key: iTarif,
                            class: [
                              {
                                "ligne-selectionnee":
                                  tarif.tarifId === _vm.idTarifSelectionne
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.selectionnerTarif(tarif)
                              }
                            }
                          },
                          [
                            [
                              _c("td", { staticClass: "aligner-gauche" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.nomFournisseur(tarif.fournisseurId)
                                  )
                                )
                              ]),
                              _c("td", { staticClass: "aligner-gauche" }, [
                                _vm._v(_vm._s(tarif.designation))
                              ]),
                              _c("td", [_vm._v(_vm._s(tarif.marque))]),
                              _c("td", [_vm._v(_vm._s(tarif.reference))]),
                              _c("td", [_vm._v(_vm._s(tarif.pu) + " €")]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(tarif.pcb) +
                                    " " +
                                    _vm._s(_vm.produitsHM.produits[0].uc)
                                )
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " + _vm._s(_vm.formatAllergene(tarif)) + " "
                                ),
                                _vm.sansAllergene(tarif)
                                  ? _c("em", { staticClass: "error ml-2" }, [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-exclamation-triangle ligne-modifiee"
                                      }),
                                      _vm._v(" Produit sans allergene ")
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          ],
                          2
                        )
                      }),
                      0
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        staticClass:
          "table table-bordered table-sm text-center table-header-secondary"
      },
      [
        _c("colgroup", [
          _c("col", { attrs: { width: "165" } }),
          _c("col"),
          _c("col", { attrs: { width: "100" } }),
          _c("col", { attrs: { width: "100" } }),
          _c("col", { attrs: { width: "100" } }),
          _c("col", { attrs: { width: "100" } }),
          _c("col", { attrs: { width: "255" } })
        ]),
        _c("thead", [
          _c("th", { staticClass: "aligner-gauche" }, [_vm._v("Fournisseur")]),
          _c("th", { staticClass: "aligner-gauche" }, [_vm._v("Désignation")]),
          _c("th", [_vm._v("Marque")]),
          _c("th", [_vm._v("Référence")]),
          _c("th", [_vm._v("P.U.")]),
          _c("th", [_vm._v("PCB")]),
          _c("th", [_vm._v("Allergènes")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "165" } }),
      _c("col"),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "250" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }